import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirplaneIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirplaneGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.0113 22C11.4169 22 10.8868 21.6923 10.5914 21.1757L9.96862 20.0858C9.74062 19.6891 9.62014 19.2356 9.62014 18.7759V14.0504L3.7299 11.8791C3.48089 11.7877 3.31592 11.5504 3.31592 11.286V8.89725C3.31592 8.71189 3.39685 8.5364 3.53773 8.41654C3.67861 8.29544 3.8615 8.246 4.0481 8.27196L9.62013 9.15676V6.17735L8.04824 5.07382C7.87956 4.95519 7.77885 4.76242 7.77885 4.55604V2.6332C7.77885 2.43424 7.87215 2.24765 8.03032 2.12778C8.18912 2.00915 8.39364 1.96961 8.58456 2.02398L12.0459 3.00764L15.4115 2.02521C15.6018 1.97208 15.8088 2.00667 15.9682 2.12654C16.1276 2.24642 16.2215 2.43424 16.2215 2.6332V4.55604C16.2215 4.75994 16.1233 4.95148 15.9577 5.07012L14.3803 6.20207V9.18147L19.9492 8.2732C20.1321 8.23736 20.3193 8.2942 20.4608 8.4153C20.6023 8.53518 20.6839 8.71189 20.6839 8.89725V11.286C20.6839 11.5492 20.5207 11.7852 20.2742 11.8779L14.3803 14.0998V18.7883C14.3803 19.2344 14.2654 19.678 14.0479 20.071L13.4417 21.1597C13.1501 21.6824 12.6193 21.9963 12.0212 22L12.0113 22ZM4.58135 10.8448L10.4716 13.016C10.7206 13.1075 10.8856 13.3448 10.8856 13.6092V18.7759C10.8856 19.0144 10.948 19.2504 11.0666 19.4568L11.6901 20.548C11.7871 20.7185 11.9459 20.7741 12.0138 20.7346C12.0793 20.7346 12.2406 20.7148 12.3357 20.5443L12.9413 19.4568C13.0549 19.2517 13.1149 19.0206 13.1149 18.7883V13.6623C13.1149 13.3991 13.278 13.1631 13.5245 13.0704L19.4185 10.8485V9.6412L13.8495 10.5495C13.6648 10.5816 13.4788 10.5272 13.3379 10.4074C13.1964 10.2875 13.1149 10.1108 13.1149 9.92542V5.87708C13.1149 5.67319 13.2131 5.48164 13.3787 5.36301L14.9562 4.23106V3.47725L12.2258 4.27431C12.1108 4.3052 11.9903 4.3089 11.8754 4.27555L9.0443 3.47107V4.22736L10.6162 5.33089C10.7849 5.44952 10.8856 5.6423 10.8856 5.84867V9.89825C10.8856 10.0836 10.8046 10.2591 10.6638 10.379C10.5229 10.5001 10.3406 10.5507 10.1534 10.5235L4.58137 9.63874L4.58135 10.8448Z"
        fill="#696969"
      />
    </svg>
  );
};

export default AirplaneIcon;
